var baseApiUrl = process.env.REACT_APP_MANAGE_ISSUE_BASE_URL;
const baseurl = baseApiUrl + "api";
const baseurlforreports = `${baseurl}/leaseoperatorscraperqcreports`;
export const PROVIDER_REPORTS = `${baseurlforreports}/getallprovidernames`;
export const PROVIDER_REPORTS_EXPORT = `${baseurlforreports}/exportallprovidernames`;
export const BAU_REPORTS = `${baseurlforreports}/getallbaustatusreport`;
export const BAU_REPORTS_EXPORT = `${baseurlforreports}/exportallbaustatusreport`;
export const PROVIDER_FILTER  = `${baseurlforreports}/getallprovidernamefilters`;
export const BAU_FILTER  = `${baseurlforreports}/getallbaustatusreportfilters`;
